import { useContext } from "react";
import "./ViewSottoCategoryComponent.scss";
import { AppContext } from "../../../../../../contexts/appContext";
import BreadcrumbComponent from "../../../../../../components/BreadcrumbComponent/BreadcrumbComponent";
import { CategoryTitle } from "../../../../../../components/styled-components";
import { BREADCRUMB_MAP } from "../../../../../../utils/BreadcrumbEnums";
import CategoryDetailViewTextComponent from "../CategoryDetailViewTextComponent/CategoryDetailViewTextComponent";
import CategoryDetailNotaMetodologicaComponent from "../CategoryDetailNotaMetodologicaComponent/CategoryDetailNotaMetodologicaComponent";
import CategoryDetailViewImageComponent from "../CategoryDetailViewImageComponent/CategoryDetailViewImageComponent";
import CategoryDetailAllegattiListComponent from "../CategoryDetailAllegattiListComponent/CategoryDetailAllegattiListComponent";
import CategoryDetailAppListComponent from "../CategoryDetailAppListComponent/CategoryDetailAppListComponent";
import CategoryDetailMoreInformationComponent from "../CategoryDetailMoreInformationComponent/CategoryDetailMoreInformationComponent";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../../../../../utils/Constans";

/**
 * @function ViewSottoCategoryComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
 */
const ViewSottoCategoryComponent = ({ info}) => {
    const { menu } = useContext( AppContext );

    let currentSection;
    let currentCategory;
    menu?.forEach(m => {
        let vociMenu = m.voci;
        vociMenu.forEach(v => {
            if (v.idContenuto === info?.idPadre) {
                currentSection = m;
                currentCategory = v;
            }
        });
    });
    const { contenuto } = info;
    return (
        <>
            <BreadcrumbComponent items={ [BREADCRUMB_MAP.HOME_PAGE, { name: currentSection?.etichetta, href: "", sezione: currentSection, categoria: "" }, { name: currentCategory?.nome, href: "", sezione: "", categoria: currentCategory }] }></BreadcrumbComponent>
            <Helmet>
                <title>{APP_NAME} | { contenuto?.titoloContenuto?.titoloContenuto }</title>
            </Helmet>
            <CategoryTitle role="contentinfo" tabIndex="0" aria-labelledby={contenuto?.titoloContenuto?.titoloContenuto}>{ contenuto?.titoloContenuto?.titoloContenuto }</CategoryTitle>
            <CategoryDetailViewTextComponent info={ contenuto?.contenuto?.testoContenuto }></CategoryDetailViewTextComponent>
            <CategoryDetailNotaMetodologicaComponent info={ contenuto?.notaMetodologica?.testoNota }></CategoryDetailNotaMetodologicaComponent>
                {
                contenuto?.immagini?.map( img => {
                    const { didascalia, immagine, allegato } = img;
                    return (
                        <CategoryDetailViewImageComponent
                            key = { didascalia }
                            title={ didascalia }
                            src={ immagine }
                            alt={ didascalia }
                            allegato={ allegato }
                        >
                        </CategoryDetailViewImageComponent>
                    );
                } )
            }
            <CategoryDetailAllegattiListComponent items={ contenuto?.allegati }></CategoryDetailAllegattiListComponent>
            <CategoryDetailAppListComponent items={ contenuto?.approfondimenti }></CategoryDetailAppListComponent>
            <CategoryDetailMoreInformationComponent info={ contenuto?.maggioriInformazioni }></CategoryDetailMoreInformationComponent>
        </>
    );
};


ViewSottoCategoryComponent.defaultProps = {
    info: [],
};

export default ViewSottoCategoryComponent;